import { assetsV1Api } from "../../lib/api";
export const getAssets = async (paramsList) => {
    const { downSelectPartyNumber, limit = 20, partyNumber, serialNumber, skip } = paramsList ?? {};
    const params = {
        ...(partyNumber && { partyNumber }),
        ...(downSelectPartyNumber && { downSelectPartyNumber }),
        ...(serialNumber && { serialNumber }),
        ...(limit && { limit: String(limit) }),
        ...(skip && { skip: String(skip) })
    };
    const queryParams = new URLSearchParams(params).toString();
    const { data } = await assetsV1Api.get(`/assets${queryParams ? "?" + queryParams : ""}`);
    return data;
};
